"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespaces = void 0;
const i18next_1 = __importDefault(require("i18next"));
const i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
const i18next_http_backend_1 = __importDefault(require("i18next-http-backend"));
const react_i18next_1 = require("react-i18next");
const cad3d_json_1 = __importDefault(require("./locales/en/cad3d.json"));
exports.namespaces = [
    'account',
    'authorization',
    'widgets',
    'catalog',
    'catalog-widget',
    'cad3d',
    'common',
    'input',
    'messages',
    'notifications',
    'profile',
    'project',
    'quote-widget',
    'translation',
    'widgets',
];
i18next_1.default
    .use(i18next_http_backend_1.default)
    .use(i18next_browser_languagedetector_1.default)
    .use(react_i18next_1.initReactI18next)
    .init({
    react: {
        useSuspense: false,
    },
    ns: exports.namespaces,
    resources: { en: { cad3d: cad3d_json_1.default } },
    partialBundledLanguages: true,
    fallbackLng: 'en',
    debug: false,
    detection: {
        order: ['localStorage', 'queryString', 'cookie'],
        caches: ['localStorage'],
    },
    interpolation: {
        escapeValue: false,
    },
});
exports.default = i18next_1.default;
